<script>
  import * as d3 from "d3";
  import { onMount } from "svelte";

  export let evictions = [];

  var geojson;
  var legend;

  let evictions_by_street = new Map();
  let all_street = [];
  let markers = [];
  let mapcluster;
  let markersLayer;

  $: evictions_by_street = d3.group(evictions, (d) => d.street);
  $: all_streets = Array.from(d3.group(evictions, (d) => d.street)).map(
    (d) => d[1][0]
  );

  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //
  // ### BEGIN CLUSTER MAP ### //

  var mapboxAccessToken =
    "pk.eyJ1IjoiZ3JhY2Vnc3kiLCJhIjoiY2tpN3c3djh1NGxjZTJ4cm16bGdxNHI5ZCJ9.DD9X7XuTcY42PffpEqNo-g";

  onMount(() => {
    mapcluster = L.map("mapcluster", {
      minZoom: 9,
      maxZoom: 18,
      preferCanvas: true,
    }).setView([33.82, -84.3], 10);

    L.tileLayer(
      "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
      {
        attribution:
          'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 22,
        id: "mapbox/light-v9",
        tileSize: 512,
        zoomOffset: -1,
        accessToken: mapboxAccessToken,
      }
    ).addTo(mapcluster);

    markersLayer = L.layerGroup(markers);
    legend.addTo(mapcluster);
  });

  // Arbitrary for now
  let clusterExtent = d3.extent(evictions, (d) => d.AddTotCount);
  let clusterScale = d3.scaleLinear().domain(clusterExtent).range([5, 30]);
  let clusterColorScale = d3
    .scaleLinear()
    .domain([0, clusterExtent[1]])
    .interpolate(d3.interpolateHcl)
    .range([d3.hcl("#fed98e"), d3.hcl("#e34a33")]);

  let intervalValues = [];
  let intervalCount = 10;
  let intervalWidth =
    (clusterExtent[1] - clusterExtent[0]) / (intervalCount - 1);
  let legendData = [];

  for (let i = 0; i < clusterExtent[1] + 1; i += intervalWidth) {
    legendData.push({ value: Math.round(i), color: clusterColorScale(i) });
  }

  let customOptions = { className: "cluster-popup" };

  // for (let [i, e] of evictions_by_street) {
  // 	if (!e.latitude || !e.longitude) {continue}
  // 	let circle = L.circleMarker([e.latitude, e.longitude], {
  //     	radius: clusterScale(e.AddTotCount),
  //     	fillOpacity: 0.8,
  //     	opacity: 0,
  //     	fillColor: clusterColorScale(e.AddTotCount),
  // 	}).bindPopup(`<b>${e.filingdate}</b><br/>${e.county}<br/>${e.street}`, customOptions)
  // 	markers.push(circle)
  // 	console.log("hi", markers)
  // }

  // console.log(markers)

  // markersLayer = L.layerGroup(markers)
  // markersLayer.addTo(mapcluster)

  function chart(evictions) {
    let canvas = { height: 150, width: 300, margin: 25 };

    var div = d3.create("div");
    div.append("b").text("Address: " + evictions[0].street);
    div
      .append("p")
      .style("margin", "0px")
      .text("County: " + evictions[0].county);
    div
      .append("p")
      .style("margin", "0px")
      .text("ZIP Code: " + evictions[0].zip);
    div
      .append("p")
      .style("margin", "0px")
      .text("Count: " + evictions.length);
    var svg = div
      .append("svg")
      .attr("height", canvas.height)
      .attr("width", canvas.width);

    let xScale = d3
      .scaleTime()
      .domain(d3.extent(evictions, (d) => new Date(d.filingdate)))
      .range([canvas.margin, canvas.width - canvas.margin]);

    let month_extent = d3.extent(evictions, (d) => new Date(d.filingdate));
    let month_bins = d3.timeMonths(
      d3.timeMonth.offset(month_extent[0], -1),
      d3.timeMonth.offset(month_extent[1], 1)
    );

    let binByMonth = d3
      .bin()
      .value((d) => new Date(d.filingdate))
      .thresholds(month_bins);

    let binned_evictions = binByMonth(evictions);

    // console.log(binned_evictions)

    let yScale = d3
      .scaleLinear()
      .domain([0, d3.max(binned_evictions, (d) => d.length)])
      .range([canvas.height - canvas.margin, canvas.margin]);

    var lineInterpolate = d3
      .line()
      .x(function (d) {
        return xScale(new Date(d.date));
      })
      .y(function (d) {
        return yScale(d.value);
      });

    // Add y axis
    svg
      .append("g")
      .attr("transform", `translate(${canvas.margin}, 0)`)
      .call(
        d3
          .axisRight(yScale)
          .ticks(2)
          .tickFormat(d3.format(".0s"))
          .tickSize(canvas.width - canvas.margin * 2)
      )
      .call((g) => g.select(".domain").remove())
      .call((g) =>
        g
          .selectAll(".tick:not(:first-of-type) line")
          .attr("stroke-opacity", 0.2)
          .attr("stroke-dasharray", "2,2")
      )
      .call((g) =>
        g
          .selectAll(".tick text")
          .attr("text-anchor", "end")
          .attr("x", -5)
          .attr("dy", -4)
      );

    // Add bar for each bin
    svg
      .selectAll(".bar")
      .data(binned_evictions)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("x", (d) => xScale(d.x0))
      .attr("width", (d) => xScale(d.x1) - xScale(d.x0) - 1)
      .attr("y", (d) => yScale(d.length))
      .attr("height", (d) => canvas.height - canvas.margin - yScale(d.length))
      .attr("fill", "steelblue");

    function formatDate(d) {
      const diffTime = Math.abs(month_extent[1] - month_extent[0]);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays < 120) {
        // Month day year
        return d3.timeFormat("%b %e %Y")(d);
      } else if (d.getMonth() === 0) {
        return d3.timeFormat("%Y")(d);
      } else {
        return d3.timeFormat("%b")(d);
      }
      // console.log(d, d.getMonth(), d.getYear())
    }

    // Add x axis
    let diffTime = Math.abs(month_extent[1] - month_extent[0]);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 120) {
      svg
        .append("g")
        .attr("transform", `translate(0, ${canvas.height - canvas.margin})`)
        .call(
          d3
            .axisBottom(xScale)
            .ticks(3)
            .tickFormat((d) => formatDate(d))
        );
    } else {
      svg
        .append("g")
        .attr("transform", `translate(0, ${canvas.height - canvas.margin})`)
        .call(
          d3
            .axisBottom(xScale)
            .ticks(5)
            .tickFormat((d) => formatDate(d))
        );
    }

    return div.node();
  }

  $: if (all_streets && mapcluster && markersLayer) {
    markersLayer.clearLayers();

    markers = [];
    for (let e of all_streets) {
      if (!e.latitude || !e.longitude) {
        continue;
      }
      let circle = L.circleMarker([e.latitude, e.longitude], {
        radius: clusterScale(evictions_by_street.get(e.street).length),
        fillOpacity: 0.8,
        opacity: 0,
        fillColor: clusterColorScale(evictions_by_street.get(e.street).length),
      }).bindPopup(function () {
        return chart(evictions_by_street.get(e.street));
        // console.log(evictions_by_street.get(e.street))
        // return `<b>${e.county}</b><br/>${e.street}`
      }, customOptions);
      markers.push(circle);
    }

    markersLayer = L.layerGroup(markers);
    markersLayer.addTo(mapcluster);
  }

  // Legend
  var legend = L.control();

  legend.onAdd = function (map) {
    this._div = L.DomUtil.create("div", "legend"); // create a div with a class "legend"
    this.update();
    return this._div;
  };

  // method that we will use to update the control based on feature properties passed
  legend.update = function (props) {
    let legendSvg = d3
      .select(this._div)
      .append("svg")
      .attr("class", "legend")
      .attr("width", 270)
      .attr("height", 50);

    legendSvg
      .selectAll("rect")
      .data(legendData)
      .enter()
      .append("rect")
      .attr("fill", (d) => d.color)
      .attr("x", (d, i) => i * (250 / legendData.length) + 10)
      .attr("y", 15)
      .attr("height", 15)
      .attr("width", 250 / legendData.length);

    legendSvg
      .selectAll("text")
      .data(legendData)
      .enter()
      .append("text")
      .attr("x", (d, i) => i * (250 / legendData.length) + 10)
      .attr("y", 10)
      .attr("font-size", 8)
      .attr("text-anchor", "middle")
      .text((d, i) => {
        if (i % 2 === 0) {
          return d.value;
        } else {
          return "";
        }
      });

    legendSvg
      .append("text")
      .attr("x", 250 + 10)
      .attr("y", 10)
      .attr("font-size", 8)
      .attr("text-anchor", "middle")
      .text(clusterExtent[1]);
  };
</script>

<div id="mapcluster" />

<style>
  #mapcluster {
    height: 70vh;
    width: auto;
    margin: 25px;
  }
</style>
